module.exports = __webpack_public_path__ + "static/media/ultima.7e6011a0.jpg";